import Api from "./axiosInstance"
import config from "../../utils/config/config";
import axios from "axios";
import { isUserOnline } from "../storage/LocalStorage";

const loginUser = async (email, password, appType, otpToken) => {
  try {
    const userDetails = {
      email,
      password,
      platform: 'web',
      appType,
      ...(otpToken && { otpToken })
    };

    const response = await Api.post('/grpc/auth.AuthService/FrontmSignin', userDetails);
    return response.data;
  } catch (error) {
    console.error("Login failed:", error);
    throw error;
  }
};

const getDomainUser = async () => {
  try {
    const response = await Api.get('/grpc/user.UserService/GetUserDomains');
    return response.data;
  } catch (error) {
    console.error("Login failed:", error);
    throw error;
  }
};

const getUserProfilePic = (userId) => {
  try {
    const response = `${config.userImageBaseUrl}/${userId}_75x75.png`;
    return response;
  } catch (error) {
    console.error("Error in get User profile pic API:", error);
    throw error;
  }
};


const updateLastLoggedInDomain = async (data) => {
  try {
    const response = await Api.post('/grpc/user.UserService/UpdateLastLoggedInDomain', data);
    return response.data;
  } catch (error) {
    console.error("Login failed:", error);
    throw error;
  }
};

const doGoogleSignin = async (data) => {
  if(!isUserOnline()) return ;

  try {
    const response = await Api.post('/grpc/auth.AuthService/GoogleSignin', data);
    return response.data;
  } catch (error) {
    console.error("Gogle signin failed:", error);
    throw error;
  }
};

const loginWithJWT = async (params) => {
  try {
    const response = await axios.post(config.jwtLoginURL, params,
      {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": config.xApiKeyForJwtLogin,
        },
      }
    );

    console.log("Login successful:", response.data);
    return response.data;

  } catch (err) {
    console.error("Login failed:", err.response?.data || err.message);
    throw err;
  }
};

export default { loginUser, getDomainUser, getUserProfilePic, updateLastLoggedInDomain, doGoogleSignin, loginWithJWT };
